<div class="dz-row" *ngFor="let row of GHOST_ROWS">
	<div class="dz-col-7 dz-col-sm-7">
		<ngx-skeleton-loader [theme]="{ width: '80%', 'border-radius': '0', height: '25px' }"></ngx-skeleton-loader>
	</div>
	<div class="dz-col-7 dz-col-sm-7">
		<ngx-skeleton-loader [theme]="{ width: '50%', 'border-radius': '0', height: '10px' }"></ngx-skeleton-loader>
		<ngx-skeleton-loader [theme]="{ width: '70%', 'border-radius': '0', height: '20px' }"></ngx-skeleton-loader>
	</div>
	<div class="dz-col-2 dz-col-sm-2">
		<ngx-skeleton-loader [theme]="{ width: '60%', 'border-radius': '0', height: '10px' }"></ngx-skeleton-loader>
		<ngx-skeleton-loader [theme]="{ width: '80%', 'border-radius': '0', height: '20px' }"></ngx-skeleton-loader>
	</div>
	<div class="dz-col-3 dz-col-sm-3">
		<ngx-skeleton-loader [theme]="{ width: '60%', 'border-radius': '0', height: '10px' }"></ngx-skeleton-loader>
		<ngx-skeleton-loader [theme]="{ width: '80%', 'border-radius': '0', height: '20px' }"></ngx-skeleton-loader>
	</div>
	<div class="dz-col-3 dz-col-sm-3">
		<ngx-skeleton-loader [theme]="{ width: '80%', 'border-radius': '0', height: '15px' }"></ngx-skeleton-loader>
	</div>
	<div class="dz-col-2 dz-col-sm-2">
		<ngx-skeleton-loader [theme]="{ width: '20px', 'border-radius': '0', height: '15px' }"></ngx-skeleton-loader>
	</div>
</div>
